/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Node_Target_StepInputs */

const en_automation_node_target_step = /** @type {(inputs: Automation_Node_Target_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target step`)
};

const pt_br2_automation_node_target_step = /** @type {(inputs: Automation_Node_Target_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa alvo`)
};

/**
* | output |
* | --- |
* | "Target step" |
*
* @param {Automation_Node_Target_StepInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_node_target_step = /** @type {((inputs?: Automation_Node_Target_StepInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Node_Target_StepInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_node_target_step(inputs)
	return pt_br2_automation_node_target_step(inputs)
});